import { render, staticRenderFns } from "./personalizedButton.vue?vue&type=template&id=20a4a11e&scoped=true"
import script from "./personalizedButton.vue?vue&type=script&lang=js"
export * from "./personalizedButton.vue?vue&type=script&lang=js"
import style0 from "./personalizedButton.vue?vue&type=style&index=0&id=20a4a11e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a4a11e",
  null
  
)

export default component.exports